import { RachelChatOutput } from '../../../../services/modules/rachelChats/rachelChats.types';
import {
  DATE_STRING_FORMAT,
  formatDate,
  isDateToday,
  isDateYesterday,
} from '../../../../utils/dates';

export type RachelChatGroupLabelKey = 'today' | 'yesterday' | 'older';

export interface RachelChatGroup {
  labelKey: RachelChatGroupLabelKey;
  dateLabel?: string;
  chats: RachelChatOutput[];
}

const getGroupKey = (date: Date): string => {
  if (isDateToday(date)) {
    return 'today';
  }
  if (isDateYesterday(date)) {
    return 'yesterday';
  }
  return formatDate(date, DATE_STRING_FORMAT);
};

export interface FlattenedRachelChatGroups {
  groupCounts: number[];
  chats: RachelChatOutput[];
}

export const flattenChatGroups = (groups: RachelChatGroup[]): FlattenedRachelChatGroups => ({
  groupCounts: groups.map((group) => group.chats.length),
  chats: groups.flatMap((group) => group.chats),
});

export const groupChatsByDay = (chats: RachelChatOutput[]): RachelChatGroup[] => {
  const groupsByKey = new Map<string, RachelChatGroup>();

  for (const chat of chats) {
    const date = new Date(chat.lastMessageAt);
    const key = getGroupKey(date);
    const existingGroup = groupsByKey.get(key);

    if (existingGroup) {
      existingGroup.chats.push(chat);
      continue;
    }

    const labelKey: RachelChatGroupLabelKey =
      key === 'today' || key === 'yesterday' ? key : 'older';

    groupsByKey.set(key, {
      labelKey,
      dateLabel: labelKey === 'older' ? formatDate(date) : undefined,
      chats: [chat],
    });
  }

  return [...groupsByKey.values()];
};
